import {Component, computed, effect, inject, viewChild} from '@angular/core';
import {PageGridComponent} from "../../../shared/components/page-grid/page-grid.component";
import {AdminPanelFilterService} from "../../service/admin-panel-filter.service";
import {GridEventOutput, GridModel} from "../../../shared/model/page-grid";
import {IErrorLog, IErrorLogsResponse} from "../../interfaces/admin-panel.interface";
import {ErrorLogsGridService} from "../../service/error-logs-grid.service";
import moment from "moment";
import {ErrorLogsDetailsModalComponent} from "../error-logs-details-modal/error-logs-details-modal.component";
import {MatDialog} from "@angular/material/dialog";
import {DatePipe} from "@angular/common";

@Component({
  selector: 'app-error-logs-list',
  templateUrl: './error-logs-list.component.html',
  standalone: false,
})
export class ErrorLogsListComponent {
  private readonly adminPanelFilterService = inject(AdminPanelFilterService);
  private readonly errorLogsGridService = inject(ErrorLogsGridService);
  private readonly dialog = inject(MatDialog);
  private readonly datePipe = inject(DatePipe);

  protected readonly salesActivityTravelTypeListRef = viewChild.required(PageGridComponent);

  protected readonly gridConfig = computed<GridModel<IErrorLogsResponse>>(() => ({
    gridDataTestId: 'error-logs-list',
    gridTitle: 'Error Logs',
    defaultPageSize: 15,
    replayButton: true,
    singleColumnFilter: true,
    columns: [
      {
        columnProperty: 'id',
        columnHeader: 'Id',
        sort: true,
        clickable: true,
      },
      {
        columnProperty: 'name',
        columnHeader: 'Name',
        sort: true,
        extraWidth: true,
        textLeft: true,
      },
      {
        columnProperty: 'timestamp',
        columnHeader: 'Timestamp',
        sort: true,
        processData: (item) => this.datePipe.transform(item, 'M/dd/yyyy') ?? '',
      },
      {
        columnProperty: 'requestUrl',
        columnHeader: 'Request Url',
        sort: true,
        extraWidth: true,
        wrapContent: true,
        textLeft: true,
      },
      {
        columnProperty: 'statusCode',
        columnHeader: 'Status Code',
        sort: true,
      },
      {
        columnProperty: 'httpMethod',
        columnHeader: 'Http Method',
        sort: true,
      },
      {
        columnProperty: 'errorMessage',
        columnHeader: 'Error Message',
        sort: true,
        extraWidth: true,
        textLeft: true,
      }
    ],
    filtersInitial: {
      DateFrom: moment(this.adminPanelFilterService.filtersValue().DateFrom).format('YYYY-MM-DD'),
      DateTo: moment(this.adminPanelFilterService.filtersValue().DateTo).format('YYYY-MM-DD'),
    },
    gridGetService: this.errorLogsGridService,
  }));

  constructor() {
    effect(() => {
      const filters = this.adminPanelFilterService.filtersValue();
      if (!filters.ReloadGrid) return;
      this.salesActivityTravelTypeListRef().getItems();
    });
  }

  protected handleItemClick({column, item}: GridEventOutput<IErrorLog>): void {
    if (column === 'id') {
        this.openErrorDialog(item.id);
    }
  }

  private openErrorDialog(id: number) {
    const dialog = this.dialog.open(ErrorLogsDetailsModalComponent, {
      width: '65%',
    });
    dialog.componentInstance.id.set(id);
  }

}
